import Button from '@components/Button';
import Tooltip from '@components/Tooltip';
import colors from '@constants/colors';
import useIsEmailSignIn from '@hooks/auth/useIsEmailSignIn';
import PhoneFill from '@icons/phone/PhoneFill';
import SocialHomepageIcon from '@icons/social/SocialHomepageIcon';
import { Link } from '@stackflow/link';
import { useTranslation } from 'react-i18next';

import RecentToolTip from '../RecentToolTip';

interface Props {
    isLastLogin?: boolean;
}

function PhoneSignInButton({ isLastLogin }:Props) {
    const { t } = useTranslation('signIn');
    const isEmail = useIsEmailSignIn();
    const textKey = isEmail ? 'phone.buttonEmail' : 'phone.button';
    return (
        <Link activityName='SignInWithPhoneActivity'
            style={{ width: '100%' }}
            activityParams={{}}>
            <Button fullWidth
                unmanagedBackground={colors.buttonDisabled}
                unmanagedColor={colors.textPrimary} >
                {isEmail ? (
                    <SocialHomepageIcon color={colors.gray9}
                        size={18}/>)
                    : (<PhoneFill color={colors.gray9}
                        size={18}/>)}
                {t(textKey)}
                {isLastLogin && (
                    <RecentToolTip/>
                )}
            </Button>
        </Link>
    );
}

export default PhoneSignInButton;
